import script from "./CalculatorExample.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorExample.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorExample.vue?vue&type=style&index=0&id=701f47ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701f47ce"]])

export default __exports__